const AboutApp  = 
[{
  "name": "NEET Mock Test",
  "title": "Neet PYQ, mocktest topimportant questions and so on",
  "link": "https://play.google.com/store/apps/details?id=com.mystudyplace.neetmocktest",
  "symbol": "./../../logo.png",
  "supportEmail": "support@mystudyplace.in",
  "address": "Suti, Murshidabad, WestBangal, India, 742201"
  
}
]




export default  AboutApp;